import { render } from "./ReceiptGenerator.vue?vue&type=template&id=6895f5ca"
import script from "./ReceiptGenerator.vue?vue&type=script&lang=js"
export * from "./ReceiptGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__